/* ============================================================================
   Solfie — Link in Bio: contador de visitas, cliques e compartilhar.
   Sem dependências. O endpoint é o Worker de métricas (data-* vem da seção).
   ========================================================================== */
(function () {
  'use strict';

  function raiz() {
    return document.querySelector('[data-sbio]');
  }

  function endpoint(el) {
    return (el.dataset.endpoint || '').replace(/\/+$/, '');
  }

  function corpo(dados) {
    return new Blob([JSON.stringify(dados)], { type: 'application/json' });
  }

  function formatar(n) {
    try {
      return Number(n || 0).toLocaleString('pt-BR');
    } catch (e) {
      return String(n);
    }
  }

  /* ---------------------------------------------------------------- visitas */
  function contarVisita(el) {
    var base = endpoint(el);
    if (!base) return;
    var site = el.dataset.site || 'bio';
    var ver = el.dataset.exibirContador === 'true';
    var alvo = ver ? el.querySelector('[data-sbio-visitas]') : null;
    var dados = { site: site, pagina: location.pathname, ref: document.referrer || '' };

    // O /hit devolve o total JÁ com esta visita; usamos a própria resposta no rodapé
    // (antes buscávamos /visitas em paralelo e o número ficava 1 atrás).
    var mostrar = function (d) {
      if (!alvo || !d) return;
      var valor = (d.total != null ? d.total : d.visitas) || 0;
      alvo.textContent = formatar(valor);
      var wrap = el.querySelector('[data-sbio-visitas-wrap]');
      if (wrap) wrap.hidden = false;
    };

    var buscarVisitas = function () {
      if (!alvo) return;
      fetch(base + '/visitas?site=' + encodeURIComponent(site) + '&json=1')
        .then(function (r) { return r.json(); })
        .then(mostrar)
        .catch(function () { /* silencioso */ });
    };

    var beacon = function () {
      try { navigator.sendBeacon(base + '/hit', corpo(dados)); } catch (e) { /* ignora */ }
    };

    // fetch(keepalive) permite LER a resposta e sobrevive ao unload (como o beacon).
    // Só cai no beacon se a requisição em si falhar — evita contar a visita duas vezes.
    try {
      fetch(base + '/hit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dados),
        keepalive: true,
      })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(mostrar)
        .catch(function () { beacon(); buscarVisitas(); });
    } catch (e) {
      beacon();
      buscarVisitas();
    }
  }

  /* ----------------------------------------------------------------- cliques */
  function contarClique(el, id, url, destino) {
    var base = endpoint(el);
    if (!base) return;
    var dados = { site: el.dataset.site || 'bio', id: id, url: destino || url };
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(base + '/clique', corpo(dados));
      } else {
        fetch(base + '/clique', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(dados), keepalive: true });
      }
    } catch (e) { /* ignora */ }
  }

  /* ------------------------------------------------------------ compartilhar */
  function compartilhar(el) {
    var botao = el.querySelector('[data-sbio-share]');
    if (!botao) return;
    var texto = botao.dataset.texto || document.title;
    var url = botao.dataset.url || location.href;
    botao.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({ title: document.title, text: texto, url: url }).catch(function () {});
        return;
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var original = botao.getAttribute('aria-label') || '';
          botao.setAttribute('aria-label', 'Link copiado!');
          botao.dataset.copiado = '1';
          setTimeout(function () { botao.setAttribute('aria-label', original); delete botao.dataset.copiado; }, 2000);
        });
      }
    });
  }

  /* ------------------------------------------------------------- partículas */
  function aleatorio(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // tamanho/quantidade por tipo (base do pen "particletext", reduzido para não poluir)
  var REGRAS = {
    bubbles: { divisor: 46, max: 12, min: 3 },
    hearts: { divisor: 56, max: 10, min: 3 },
    confetti: { divisor: 40, max: 14, min: 4 },
    fire: { divisor: 40, max: 14, min: 4 },
    lines: { divisor: 46, max: 12, min: 3 },
    sunbeams: { divisor: 46, max: 12, min: 3 },
  };

  // duração (ms) de cada efeito no CSS — deve casar com as regras
  // `.sbio__link--efeito ...` do solfie-bio.css (duração + folga do atraso).
  var DURACAO = {
    bubbles: 1600,
    hearts: 1600,
    confetti: 1600,
    fire: 1000,
    lines: 1400,
    sunbeams: 1400,
    curtida: 500,
  };

  // efeito "curtida" (base do pen do CodePen): coração + onda + 6 partículas coloridas
  var CURTIDA_CORES = ['#7642F0', '#AFD27F', '#DE8F4F', '#D0516B', '#5686F2', '#D53EF3'];

  function montarLike() {
    var caixa = document.createElement('span');
    caixa.className = 'sbio__like';
    caixa.setAttribute('aria-hidden', 'true');
    var html = '<span class="sbio__like-ripple"></span>'
      + '<svg class="sbio__like-heart" viewBox="0 0 24 24" aria-hidden="true">'
      + '<path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z"/></svg>'
      + '<span class="sbio__like-particles">';
    for (var i = 0; i < CURTIDA_CORES.length; i++) {
      html += '<span class="sbio__like-particle" style="--i:' + (i + 1) + ';--cor:' + CURTIDA_CORES[i] + '"></span>';
    }
    html += '</span>';
    caixa.innerHTML = html;
    return caixa;
  }

  function semearParticulas(el) {
    var tipoGlobal = el.dataset.particulas || '';
    var soDestaque = el.dataset.particulasOnde === 'destaque';
    var intensidade = Math.min(Math.max(Number(el.dataset.particulasIntensidade || 100), 20), 200) / 100;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var alvos = el.querySelectorAll(soDestaque ? '.sbio__link--destaque' : '.sbio__link');

    Array.prototype.forEach.call(alvos, function (botao) {
      // efeito por botão: usa o do bloco quando definido; senão o global da seção
      var tipo = botao.dataset.particulas || '';
      if (!tipo || tipo === 'herdar') tipo = tipoGlobal;
      if (!tipo || tipo === 'nenhum') return;
      // efeito "curtida": coração + onda + partículas (base do CodePen)
      if (tipo === 'curtida') {
        if (botao.querySelector('.sbio__like')) return;
        botao.dataset.sbioEfeito = 'curtida';
        botao.classList.add('sbio__link--curtida');
        botao.appendChild(montarLike());
        return;
      }

      if (botao.querySelector('.sbio__particles')) return;

      var regra = REGRAS[tipo] || REGRAS.confetti;
      var largura = botao.offsetWidth || 320;
      var quantidade = Math.min(regra.max, Math.max(regra.min, Math.round((largura / regra.divisor) * intensidade)));

      // guarda o tipo para o disparo no clique (acionarEfeito)
      botao.dataset.sbioEfeito = tipo;

      var caixa = document.createElement('span');
      caixa.className = 'sbio__particles sbio__particles--' + tipo;
      caixa.setAttribute('aria-hidden', 'true');

      for (var i = 0; i < quantidade; i++) {
        var p = document.createElement('span');
        p.className = 'sbio__particle';
        // atraso POSITIVO curto: a rajada só começa quando o botão é clicado
        var estilo = 'animation-delay:' + (aleatorio(0, 22) / 100).toFixed(2) + 's;';

        if (tipo === 'bubbles') {
          var t1 = (aleatorio(30, 50) / 10).toFixed(1);
          estilo += 'top:' + aleatorio(20, 80) + '%;left:' + aleatorio(0, 95) + '%;width:' + t1 + 'px;height:' + t1 + 'px;';
        } else if (tipo === 'hearts') {
          var t2 = (aleatorio(40, 70) / 10).toFixed(1);
          estilo += 'top:' + aleatorio(20, 80) + '%;left:' + aleatorio(0, 95) + '%;width:' + t2 + 'px;height:' + t2 + 'px;';
        } else if (tipo === 'confetti') {
          p.className += ' c' + aleatorio(1, 3);
          estilo += 'top:' + aleatorio(10, 50) + '%;left:' + aleatorio(0, 100) + '%;width:' + aleatorio(4, 6) + 'px;height:' + aleatorio(2, 3) + 'px;';
        } else if (tipo === 'fire') {
          estilo += 'top:' + aleatorio(40, 70) + '%;left:' + aleatorio(-10, 100) + '%;width:' + aleatorio(4, 7) + 'px;height:' + aleatorio(4, 7) + 'px;';
        } else if (tipo === 'lines') {
          estilo += 'top:' + aleatorio(-30, 30) + '%;left:' + aleatorio(-10, 110) + '%;width:' + aleatorio(1, 2) + 'px;height:' + aleatorio(15, 45) + '%;';
        } else if (tipo === 'sunbeams') {
          estilo += 'top:' + aleatorio(-50, 0) + '%;left:' + aleatorio(0, 100) + '%;width:' + aleatorio(1, 2) + 'px;height:' + aleatorio(30, 70) + '%;';
        }
        p.setAttribute('style', estilo);
        caixa.appendChild(p);
      }
      botao.appendChild(caixa);
    });
  }

  /* ------------------------------------------------- disparo do efeito (clique) */
  // O efeito não fica mais em loop: dispara UMA vez ao clicar no botão (ou ao
  // apertar Enter/Espaço) e a classe é removida no fim, então cada clique
  // dispara de novo. O visual (animação) está no solfie-bio.css.
  function acionarEfeito(botao) {
    var tipo = botao.dataset.sbioEfeito;
    if (!tipo) return;
    if (!botao.querySelector('.sbio__particles') && !botao.querySelector('.sbio__like')) return;
    var agora = Date.now();
    // evita disparar duas vezes no mesmo toque (pointerdown + click)
    if (botao._sbioEfeitoEm && agora - botao._sbioEfeitoEm < 400) return;
    botao._sbioEfeitoEm = agora;
    botao.classList.remove('sbio__link--efeito');
    void botao.offsetWidth; // reinicia a animação se já estava tocando
    botao.classList.add('sbio__link--efeito');
    clearTimeout(botao._sbioEfeitoTimer);
    botao._sbioEfeitoTimer = setTimeout(function () {
      botao.classList.remove('sbio__link--efeito');
    }, (DURACAO[tipo] || 1400) + 400);
  }

  /* -------------------------------------------------------------------- init */
  function iniciar() {
    var el = raiz();
    if (!el) return;
    semearParticulas(el);
    contarVisita(el);
    compartilhar(el);
    el.querySelectorAll('[data-sbio-link]').forEach(function (link, indice) {
      link.style.setProperty('--i', String(indice + 1));
      // dispara o efeito ao tocar/clicar (e no teclado); o clique continua contando
      link.addEventListener('pointerdown', function () { acionarEfeito(link); });
      link.addEventListener('keydown', function (evento) {
        if (evento.key === 'Enter' || evento.key === ' ') acionarEfeito(link);
      });
      link.addEventListener('click', function () {
        acionarEfeito(link);
        contarClique(el, link.dataset.sbioLink, link.getAttribute('href'), link.dataset.destino);
      });
    });
    el.querySelectorAll('[data-sbio-social]').forEach(function (s, indice) {
      s.style.setProperty('--i', String(indice + 1));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
